import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Toast } from "antd-mobile";
import "./style";
//import { Toast } from "antd-mobile";
import Banner from "./Banner";
// import PassLogo from "../../assets/v4/success4.png";
//import VipUse from "assets/v4/vip-use4.jpg";
import VipUse from "assets/v5/vip5-2.png";
import CouponUse4 from "assets/v4/coupon-use4.png";
import CouponUse5 from "assets/v5/coupon-use5.png";
import CouponTitle4 from "assets/v4/coupon4.png";
import CouponTitle5 from "assets/v5/coupon5.png";
import Cookies from "js-cookie";
import Album from "../getVipBySign/Album";
import VipUse5 from "assets/v5/vip5-2.png";
import { TOKEN, STATIC_SRC, isIOS } from "../../utils";

let devHost = STATIC_SRC;
if (~window.location.host.indexOf("sunshy")) {
  devHost = "";
}

// let userId = null;
// const userInfo = Cookies.get(TOKEN);
// if (userInfo) {
//   userId = userInfo.split("&")[0];
// }

@withRouter
class Success extends Component {
  handleClick = e => {
    e.preventDefault();
    //站外领取体验会员领取成功页点击打开app查看
    const { itemId, couponIds, activityId, appkey, jumpDetail, userId = null } =
      this.props.location.state || {};
    window.xmLog("pv.send", "event", {
      serviceId: "activityPageClick",
      srcPage: "站外领取体验会员领取成功页",
      item: "button",
      itemId: "打开app查看",
      userId,
      productId: itemId,
      couponIds,
      activityId
    });
    const { jumpAddress } = jumpDetail;
    if (!jumpAddress) {
      Toast.info("跳转链接有误！", 2, null, false);
      return;
    }
    if (appkey === "ad6637f08a92d521a3b0a62adb9d59fd") {
      // 熊猫看书
      window.Ios_WXPandaReader = function(s) {
        window.location.href = "wx://pandareader/" + s;
      };
      const urlParam = JSON.stringify({
        apiName: "native_call",
        params: {
          appFunc: "open_sys_browser",
          data: {
            url: jumpAddress
          },
          handleId: ""
        }
      });
      if (isIOS) {
        window.Ios_WXPandaReader(urlParam);
      } else {
        window.WXPandaReader.getJsCall(urlParam);
      }
    } else {
      window.location.href = jumpAddress;
    }
  };
  componentDidMount() {
    //站外领取体验会员领取页点击立即领取
    const { itemId, couponIds, activityId, userId = null } =
      this.props.location.state || {};
    window.xmLog("pv.send", "event", {
      serviceId: "activityView",
      item: "站外领取体验会员领取成功页",
      userId,
      productId: itemId,
      couponIds,
      activityId
    });
  }
  render() {
    // console.log(this.props.location);
    const {
      phoneArea = "",
      receivedProduct = {},
      // guideToApp = 1,
      type = "",
      templateType = 5,
      jumpDetail
    } = this.props.location.state || {};
    const { needClickButton, buttonTitle } = jumpDetail;
    const { couponDetails, vipReceiveDetails } = receivedProduct;
    const hasVip = !!(vipReceiveDetails && vipReceiveDetails.length > 0);
    let vipDays = type.replace(/[^0-9]/gi, "");
    let couponNums = 0;
    let successBoxClass = "get-success-box";
    let vipUseLogo = VipUse;
    let couponTitle = CouponTitle4,
      couponUse = CouponUse4;
    if (couponDetails && couponDetails.length) {
      couponDetails.forEach(({ couponNum }) => {
        couponNums += couponNum;
      });
    }
    if (templateType === 5) {
      successBoxClass = "get-success-box template-v5";
      vipUseLogo = VipUse5;
      couponTitle = CouponTitle5;
      couponUse = CouponUse5;
    }
    // console.log(hasVip, "hasvip");
    return (
      <div className={successBoxClass}>
        <div className="content">
          {hasVip && (
            <p className="res" style={{ fontSize: "0.9rem" }}>
              恭喜您，领取成功！
            </p>
          )}
          {!hasVip && (
            <p className="res">
              {`恭喜您，${couponNums}张`}
              <span className="bigger">神券</span>领取成功!
            </p>
          )}

          <p className="received-vip">
            {hasVip ? " " : `您之前已经领取过${vipDays}天VIP会员啦~`}
          </p>

          {needClickButton === 1 && (
            <a href="" className="btn" onClick={this.handleClick}>
              {buttonTitle}
            </a>
          )}
          <p className="detail">
            使用手机号<span style={{ color: "#ff5e62" }}>{phoneArea}</span>
            登录喜马拉雅即可享受权益
          </p>
          {hasVip && (
            <div className="vip-box">
              <img src={devHost + vipUseLogo + "?v=666"} alt="vip" />
              <div className="detail">{vipDays}天VIP会员</div>
              <div className="desc">自领取日开始 {vipDays} 天有效</div>
            </div>
          )}
          {couponDetails && (
            <div className="award-list">
              <div className="title">
                <img src={couponTitle} alt="coupon" />
              </div>
              <ul className="album-lists">
                {couponDetails.map((item, i) => (
                  <li className="album-box" key={i}>
                    <Album data={item} hasBtn={false} />
                  </li>
                ))}
              </ul>
              <img src={devHost + couponUse} alt="coupon" />
            </div>
          )}
        </div>
        <div className="success-banner">
          <Banner version={templateType} />
        </div>
      </div>
    );
  }
}

export default Success;



// WEBPACK FOOTER //
// ./src/pages/getVip/Success.jsx